import { render, staticRenderFns } from "./TextOptions.vue?vue&type=template&id=52631b00&"
import script from "./TextOptions.vue?vue&type=script&lang=js&"
export * from "./TextOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports